/**
 * Browser-side error types. Smaller surface than the server SDK because
 * the browser SDK only does two HTTP calls (embed bootstrap + nothing
 * else) and the rest is postMessage choreography.
 */

export class GateError extends Error {
   constructor(message: string) {
      super(message);
      this.name = 'GateError';
      Object.setPrototypeOf(this, new.target.prototype);
   }
}

/** Caller passed an `sk_*` key — secret keys must never reach the browser. */
export class SecretKeyInBrowserError extends GateError {
   constructor() {
      super(
         'Refusing to use a secret key (sk_*) in the browser. Pass your publishable key (pk_*) here, ' +
            'and mint sessions server-side with the secret key — then forward `client_secret` to this SDK.',
      );
      this.name = 'SecretKeyInBrowserError';
   }
}

/** Constructor config rejected — missing / wrong-shaped fields. */
export class ConfigError extends GateError {
   constructor(message: string) {
      super(message);
      this.name = 'ConfigError';
   }
}

/** `mount()` called twice, or `unmount()` then `mount()` without re-init. */
export class StateError extends GateError {
   constructor(message: string) {
      super(message);
      this.name = 'StateError';
   }
}

/** Container element wasn't found or wasn't an HTMLElement. */
export class MountTargetError extends GateError {
   constructor(message: string) {
      super(message);
      this.name = 'MountTargetError';
   }
}

/** `/v1/embed/bootstrap` rejected or unreachable. */
export class EmbedBootstrapError extends GateError {
   public readonly status?: number;
   constructor(message: string, status?: number) {
      super(message);
      this.name = 'EmbedBootstrapError';
      this.status = status;
   }
}
